export default __webpack_public_path__ + "static/media/bathtub-white-18dp.169c333b.svg";